import Sensors from 'sa-sdk-javascript'

export default {
  // 首页菜单点击事件
  indexMenuClient (positionType, positionName) {
    try {
      Sensors.track('index_menu_client', {
        position_type: positionType,
        position_name: positionName
      })
    } catch (error) {
      console.log(error.message)
    }
  },
  /*
    进入注册登录页面
  */
  registerLoginClient (buttonName) {
    try {
      Sensors.track('register_login_client', {
        access_type: buttonName
      })
    } catch (error) {
      console.log(error.message)
    }
  },
  // 商品详情页
  travelProductDetailsClient (sensorsSku) {
    try {
      Sensors.track('travel_product_details_client', sensorsSku)
    } catch (error) {
      console.log(error.message)
    }
  },
  // 商品详情页按钮点击事件
  travelProductDetailsButtonClient (tabName) {
    try {
      Sensors.track('travel_product_details_button_client', {
        detail_tab: tabName
      })
    } catch (error) {
      console.log(error.message)
    }
  },
  // 城市玩家频道点击事件
  weTravelClient (pageButtonName) {
    try {
      Sensors.track('we_travel_client', {
        page_button: pageButtonName
      })
    } catch (error) {
      console.log(error.message)
    }
  },
  // 城市玩家频道筛选
  weTravelFilterClient (type, tabName, firstTabName = '') {
    var sensorsSku = {}
    if (type === 'recommend_first') {
      sensorsSku = {
        filter_recommend_first: tabName
      }
    }
    if (type === 'recommend_second') {
      sensorsSku = {
        filter_recommend_first: firstTabName,
        filter_recommend_second: tabName
      }
    }
    if (type === 'date_first') {
      sensorsSku = {
        filter_date_first: tabName
      }
    }
    if (type === 'date_second') {
      sensorsSku = {
        filter_date_first: firstTabName,
        filter_date_second: tabName
      }
    }
    if (type === 'theme_first') {
      sensorsSku = {
        filter_theme_first: tabName
      }
    }
    if (type === 'theme_second') {
      sensorsSku = {
        filter_theme_first: firstTabName,
        filter_theme_second: tabName
      }
    }
    try {
      Sensors.track('we_travel_filter_client', sensorsSku)
    } catch (error) {
      console.log(error.message)
    }
  },
  // 点击我要报名
  travelProductSignUpClient (sku, trip) {
    try {
      Sensors.track('travel_product_sign_up_client', {
        sku_id: sku.sku_id,
        sku_name: sku.sku_name,
        business_catalog: sku.business_catalog,
        recommend_label: sku.recommend_label,
        type_label: sku.type_label,
        rule_label: sku.rule_label,
        way_label: sku.way_label,
        theme_label: sku.theme_label,
        city: sku.city,
        trip_hour: sku.trip_hour,
        trip_price: trip.trip_price,
        trip_start_date: trip.trip_start_date,
        trip_end_date: trip.trip_end_date,
        holiday: trip.holidays
      })
    } catch (error) {
      console.log(error.message)
    }
  },
  // 报名前必看弹层点击事件
  layerClickClient (sku, buttonName) {
    try {
      Sensors.track('layer_click_client', {
        sku_id: sku.sku_id,
        sku_name: sku.sku_name,
        business_catalog: sku.business_catalog,
        recommend_label: sku.recommend_label,
        type_label: sku.type_label,
        rule_label: sku.rule_label,
        way_label: sku.way_label,
        theme_label: sku.theme_label,
        city: sku.city,
        trip_hour: sku.trip_hour,
        button_name: buttonName
      })
    } catch (error) {
      console.log(error.message)
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/libs/sensorscommon.js
 **/